// src/services/api.js — Centralized API service
import axios from 'axios';

// When running on a remote domain (production), use relative '/api' so requests
// go to https://crm.ziwmtech.online/api and are proxied by Nginx.
// When running locally on dev, fallback to 'http://localhost:8081/api'.
const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const rawEnvBase = process.env.REACT_APP_API_URL ? String(process.env.REACT_APP_API_URL).trim() : '';

const API_BASE = rawEnvBase
  ? rawEnvBase.replace(/\/+$/, '')
  : (isLocalhost ? 'http://localhost:8081/api' : '/api');

/**
 * Centralized Axios instance with JWT interceptors.
 * - Automatically attaches the access token to every request.
 * - On 401 (expired token), clears auth and redirects to login.
 */
const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// ─── Request interceptor: attach access token ───
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ─── Response interceptor: handle token expiry ───
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid — force logout
      const isLoginRoute = error.config?.url?.includes('/auth/login');
      if (!isLoginRoute) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('crm_user');
        if (window.location.pathname !== '/') {
          window.location.href = '/';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
